import { post } from "../../../../http";
import { FavouriteItemType } from "../../../types";
import { favouritesBaseApiUrl } from "../../favouritesBaseUrl";
import { favouriteBulkUrl } from "../../queries/favouriteItems/favouriteItems.constants";

import { FavouriteMapDraftDTO, FavouriteSlideDraftDTO, FavouriteObjectType, FavouriteBulkDraftDTO, FavouriteBulkSavedDraftDTO } from "../../types";
import { AddFavouriteMutationRequest } from "./addFavourite.types";

export const addFavourite = async (newFavouriteItem: AddFavouriteMutationRequest) => {
  if (newFavouriteItem.type === FavouriteItemType.Map) {
    const newFavouriteMapItem: FavouriteMapDraftDTO = {
      objectType: FavouriteObjectType.Map,
      name: newFavouriteItem.name,
      mark: {
        marks: newFavouriteItem.mark.parameters,
      },
    };
    await post(`${favouritesBaseApiUrl}/favourites`, newFavouriteMapItem);
  } else if (newFavouriteItem.type === FavouriteItemType.Slide) {
    const newFavouriteSlideItem: FavouriteSlideDraftDTO = {
      objectType: FavouriteObjectType.Slide,
      name: newFavouriteItem.name,
      mark: {
        reportId: newFavouriteItem.mark.reportId,
        marks: newFavouriteItem.mark.parameters,
      },
    };
    await post(`${favouritesBaseApiUrl}/favourites`, newFavouriteSlideItem);
  } else if (newFavouriteItem.type === FavouriteItemType.BulkExport) {
    const settings = newFavouriteItem.mark.parameters;
    const newFavouriteBulkItem: FavouriteBulkDraftDTO = {
      id: settings?.id,
      lastModified: newFavouriteItem.date,
      bulkExportSettings: settings,
    };
    await post(favouriteBulkUrl, newFavouriteBulkItem);
  } else if (newFavouriteItem.type === FavouriteItemType.SavedBulkExport) {
    const newFavouriteBulkItem: FavouriteBulkSavedDraftDTO = {
      savedBulkExportSettingsId: newFavouriteItem?.mark?.savedBulkExportSettingsId,
    };
    await post(favouriteBulkUrl, newFavouriteBulkItem);
  }
};
